export interface JudgeItem {
  icon: string;
  name: string;
  token?: string;
  [key: string]: any;
}

const list: JudgeItem[] = [
  {
    icon: 'https://static.bymj.io/web3/wsot/Luna_by_Virtuals @48px4x.png',
    name: 'Luna by Virtuals',
    token: 'LUNAI',
  },
  {
    icon: 'https://static.bymj.io/web3/wsot/Top_Hat@48px4x.png',
    name: 'Top Hat',
    token: 'HAT',
  },
  {
    icon: 'https://static.bymj.io/web3/wsot/Alchemist_AI@48px4x.png',
    name: 'Alchemist AI',
    token: 'ALCH',
  },
  {
    icon: 'https://static.bymj.io/web3/wsot/ai16z_@48px4x.png',
    name: 'ai16z',
    token: 'AI16Z',
  },
  {
    icon: 'https://static.bymj.io/web3/wsot/Cookie_DAO_@48px4x.png',
    name: 'Cookie DAO',
    token: 'COOKIE',
  },
];

export default list;
